import { INoteHandler, Note, NoteAddendum, NoteAddendumInsert, NoteInsert, NoteUpdate, INote, UserState } from "@harlowe/core";
import { TealCompEncounter, TealCompEncounterDetails, TealCompEncounterHeader } from "../../../models/encounter";
import { EncounterService } from "../../../services/encounter.service";
import { Store } from "@ngxs/store";



export class EncounterNoteHandler implements INoteHandler
{
    constructor
    (
        private encounter: TealCompEncounter | TealCompEncounterDetails | TealCompEncounterHeader,
        private _encounters: EncounterService,
        private _store: Store
    )
    {
        
    }

    async addNote(note: INote): Promise<Note | undefined>
    {
        var user = this._store.selectSnapshot(UserState.currentUser);
        if(user && this.encounter)
        {
            var ni = new NoteInsert(note.subject,note.body,user.id);
            ni.noteTypes = note.noteTypes;
            return await this._encounters.addNewNote(this.encounter.id,ni);
        }
        return Promise.resolve(undefined);
    }

    async updateNote(noteId: number, note: INote): Promise<Note | undefined>
    {
        if(this.encounter)
        {
            var nu = new NoteUpdate(noteId);
            nu.subject = note.subject;
            nu.body = note.body;
            nu.noteTypes = note.noteTypes;
            return await this._encounters.updateNote(this.encounter.id, noteId, nu);
        }
        return Promise.resolve(undefined);
    }

    async deleteNote(encounterId: number, noteId: number)
    {
        if(this.encounter)
        {
            return await this._encounters.deleteNote(encounterId, noteId);
        }
    }

    async addAddendum(noteId: number, body: string): Promise<NoteAddendum | undefined>
    {
        if(this.encounter)
        {
            return await this._encounters.addNoteAddendum(this.encounter.id, noteId, new NoteAddendumInsert(body));
        }
        return Promise.resolve(undefined);
    }
}